import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltip: (props: any) => ({
      minWidth: props?.minWidth ? props.minWidth : 116,
      maxWidth: props?.maxWidth ? props.maxWidth : undefined,
      borderRadius: 6,
      overflow: 'hidden',
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.11)',
      border: 'solid 1px #dedede',
      backgroundColor: '#ffffff',
    }),
    ttheader: {
      padding: theme.spacing(1),
      borderTopLeftRadius: 6,
      borderTopRightRadius: 6,
      backgroundColor: '#f0f0f0',
    },
    ttbody: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: theme.spacing(1),
      borderBottomLeftRadius: 6,
      borderBottomRightRadius: 6,
      backgroundColor: '#fff',
    },
  }),
);
